import { useParams } from 'next/navigation';
import { useOrganisationByOrgName } from './useOrganisationByOrgName';

export default function useCurrentOrganisation() {
  const pathParams = useParams<{ orgName?: string }>();
  const hasOrgSpecified = !!pathParams.orgName;
  const orgResult = useOrganisationByOrgName(pathParams.orgName ?? '');
  return {
    ...orgResult,
    hasOrgSpecified,
  };
}
